import { isDev, isStg } from 'env';
import type { PostTheme } from './types';

// The ?whats-new-preview link works on dev and staging, and for Admins anywhere; MainLayout loads its code only then.
export const previewAllowed = (isAdmin: boolean): boolean => isDev || isStg || isAdmin;

const SOLID_COLOUR = /^#[0-9a-fA-F]{6}$/;
// The glow may be see-through, as user-manager allows.
const GLOW_COLOUR = /^(#[0-9a-fA-F]{6}|rgba?\(\s*\d{1,3}\s*(,\s*\d{1,3}\s*){2}(,\s*(0|1|0?\.\d+)\s*)?\))$/;

const isColour = (value: unknown, pattern: RegExp): value is string => typeof value === 'string' && pattern.test(value);

/** The theme a preview link carries (react-admin's form, saved or not) as JSON; null for none, or one that isn't colours. */
export const previewTheme = (json: string | null): PostTheme | null => {
  if (!json) return null;
  try {
    const { surface, text, textMuted, accent, onAccent, glow } = JSON.parse(json);
    const solid = [surface, text, textMuted, accent, onAccent].every((colour) => isColour(colour, SOLID_COLOUR));
    return solid && isColour(glow, GLOW_COLOUR) ? { surface, text, textMuted, accent, onAccent, glow } : null;
  } catch {
    return null;
  }
};
